import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiBlobGetRequest,
} from '../../../api';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Master Faktur Pajak',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Master Faktur',
        href: '/adm/fin/faktur-pajak/setting-faktur',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_faktur',
    sortDesc: false,
    fields: [
      {
        key: 'start_date',
        label: 'Start Date',
        sortable: true,
      },
      {
        key: 'end_date',
        label: 'End Date',
        sortable: true,
      },
      {
        key: 'prefix_no',
        label: 'No Prefix',
        sortable: true,
      },
      {
        key: 'start_number',
        label: 'Start Number',
        sortable: true,
      },
      {
        key: 'end_number',
        label: 'End Number',
        sortable: true,
      },
      {
        key: 'efaktur',
        label: 'No E-Faktur',
        sortable: true,
      },
      {
        key: 'coretax_no',
        label: 'Coretax No',
        sortable: true,
      },
      {
        key: 'trans_no',
        label: 'Trans No',
        sortable: true,
      },
      {
        key: 'trans_type',
        label: 'Trans Type',
        sortable: true,
      },
      {
        key: 'status_faktur',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {},
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeFaktur(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchFaktur(context, params = null) {
    let result = await ApiGetRequest(`fin/faktur`, params);
    return !result.error ? result.data.object : [];
  },

  async getListFaktur({ commit, state }, payload = {}) {
    if (!payload) {
      payload = {};
    }

    commit('changeFaktur', {
      loading: true,
    });

    const { data } = state;
    let params = {
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/faktur/master-faktur`, params);
    commit('changeFaktur', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getDetailFaktur({ commit, state }, payload = null) {
    commit('changeFaktur', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/faktur/${payload.id}`);
    commit('changeFaktur', {
      loading: false,
    });

    if (!result.error) {
      commit('changeFaktur', {
        form: {
          ...data.form,
          ...result.data.object,
        },
      });
    }

    return result.error ? false : true;
  },

  async createFaktur({ commit, state, dispatch }) {
    commit('changeFaktur', {
      loading: true,
    });

    let result = await ApiPostRequest(`fin/faktur`, state.data.form);
    commit('changeFaktur', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateFaktur({ commit, state, dispatch }, payload = null) {
    commit('changeFaktur', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/faktur/${payload.id}`,
      state.data.form
    );

    commit('changeFaktur', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async cancelFaktur({ commit, dispatch }, payload = null) {
    commit('changeFaktur', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/faktur/cancel-faktur/${payload.id}`);
    commit('changeFaktur', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async deleteFaktur({ commit, dispatch }, payload = null) {
    commit('changeFaktur', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/faktur/${payload.id}`);
    commit('changeFaktur', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async getDownloadExcelFaktur({ commit }, payload = null) {
    commit('changeFaktur', {
      loading: true,
    });

    let result = await ApiBlobGetRequest(
      `fin/faktur/download-faktur/${payload ? payload.id_faktur : ''}`
    );

    if (result.error) {
      commit('changeFaktur', {
        loading: false,
      });

      return false;
    } else {
      commit('changeFaktur', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = result.data;
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_one_coretax.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },
};
